import {
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Edit,
    Visibility,
} from "@mui/icons-material";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { DeleteModal, PopupModal } from "../../Components/Modal/Modals";
import {
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    adderCategoriesReset,
    DeleteAddreGroupMembersCategory,
    GetAllCategoriesChildrens,
} from "../../Redux/AddersCategoriesSlice/AddersCategoriesSlice";
// import AdderStatusConfirm from "./AdderStatusConfirm";
import EditAdderCategory from "./EditAdderCategory";
import { useParams } from "react-router-dom";

const GroupChildrens = () => {
    const dispatch = useDispatch();
    const { group_id } = useParams();

    // Pop Up Data
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    //edit row
    const [childrens, setChildrens] = useState(false);
    const handelOpenGroupChildrens = (data) => {
        setData(data);
        setChildrens(true);
    };
    const handelCloseGroupChildrens = () => {
        setData({});
        setChildrens(false);
    };

    // Delete Adder Confirm

    const [tableId, setTableId] = useState(null);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const CallNotificationMethod = async () => {
        await toast.success("Children deleted success");
        await GetAllAddersGroupsAction();
        await dispatch(adderCategoriesReset());
    };
    const DeleteRow = async () => {
        handleClose();
        console.log(data.id)
        await dispatch(DeleteAddreGroupMembersCategory(data.id));
        await CallNotificationMethod();
        await setTableId(data.id);
    };
    const handelDeleteAdder = async (data) => {
        handleOpen(data);
    };

    const { category_childrens, isSuccess, isLoading, isError, errors } = useSelector(
        (state) => state.adders_categories
    );
    const AllCatChildrensVal = category_childrens?.data?.group_children || [];
    console.log(AllCatChildrensVal)
    const GetAllAddersGroupsAction = async () => {
        await dispatch(
            GetAllCategoriesChildrens(group_id)
        );
        await dispatch(adderCategoriesReset());
    };
    useEffect(() => {
        GetAllAddersGroupsAction();
    }, [dispatch]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                if (errors.length < 8) {
                    Object.keys(errors).forEach((key) => {
                        let error = errors[key][0];
                        toast.error(error);
                    });
                } else {
                    toast.error(errors);
                }
            }
            const reset = async () => {
                await dispatch(adderCategoriesReset());
            };
            reset();
        }
    }, [dispatch, errors, isError]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <TableContainerStyled>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell> Adder Name</TableCell>
                                <TableCell> Type </TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {AllCatChildrensVal?.map((key, index) => (
                                <TableRowStyled key={index}>
                                    <TableCellStyle>
                                        {index + 1}
                                        {/* {rowsPerPage * page + index + 1} */}
                                    </TableCellStyle>
                                    <TableCellStyle>{key?.name}</TableCellStyle>
                                    <TableCellStyle>{key?.type}</TableCellStyle>
                                    <TableCellStyle>
                                        <IconButton
                                            onClick={(e) =>
                                                handelDeleteAdder(key)
                                            }
                                        >
                                            <Link to={"#"}>
                                                <Delete color="error" />
                                            </Link>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                    </Table>

                    {/* delete modal  */}
                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.name}
                        onClick={DeleteRow}
                        loading={isLoading}
                    />
                </TableContainerStyled>
            )}
        </>
    );
};

export default GroupChildrens;
